import { render, staticRenderFns } from "./purchaseOrderReorderTable.vue?vue&type=template&id=58a71042&scoped=true&"
import script from "./purchaseOrderReorderTable.vue?vue&type=script&lang=js&"
export * from "./purchaseOrderReorderTable.vue?vue&type=script&lang=js&"
import style0 from "./purchaseOrderReorderTable.vue?vue&type=style&index=0&id=58a71042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a71042",
  null
  
)

export default component.exports